export default __webpack_public_path__ + "static/media/cookie-bite-script.9767ca61.svg";